import React from 'react';

const Loader = () => {
  return (
    <div className="skeleton-grid" aria-label="Loading deals...">
      {[1, 2, 3, 4, 5, 6].map((n) => (
        <div key={n} className="skeleton-card">
          <div className="skeleton-shimmer" />
        </div>
      ))}
    </div>
  );
};

export default Loader;